<script>
    // @check-js
    export let cart;

    import { cartPopupOpen } from "../../stores/cart-popup-open.js";
    import { onMount } from "svelte";
    import AButton from "../buttons/AButton.svelte";
    import Spacer from "../Spacer.svelte";
    import CartListingPopup from "../header/CartListingPopup.svelte";
    import { onNumChange } from "../../utils/cart-listing.utils.js";
    import Button from "$components/buttons/Button.svelte";

    /** @type {import("../../routes/server-api/product/types").ProductResponse[]}*/
    let products = [];

    const localHydrateCart = async (cart, cartValue) => {
        if (!mounted) {
            return;
        }
        let hydratedCart;
        try {
            const cartRes = await fetch(`/server-api/cart?cart=${JSON.stringify(cartValue)}`);
            if (cartRes.status !== 200) {
                return;
            }
            hydratedCart = await cartRes.json();
        } catch (e) {}

        if (!hydratedCart) {
            return;
        }
        if (!hydratedCart.products) {
            cart.clear();
            return;
        }
        if (hydratedCart.products.length !== cartValue.products.length) {
            const hydratedArtnr = hydratedCart.products.map((p) => p.artnr);
            cartValue.products.forEach((p) => {
                if (!hydratedArtnr.includes(p.artnr)) {
                    cart.delete(p.artnr);
                }
            });
        }
        if (hydratedCart.products) {
            products = hydratedCart.products;
        }
    };
    $: localHydrateCart(cart, $cart);

    const closePopup = () => {
        cartPopupOpen.close();
    };

    let mounted = false;
    onMount(() => {
        const checkMenuClick = (e) => {
            if (!$cartPopupOpen) {
                return;
            }
            if (!e.target.closest(".cart") && !e.target.closest(".cart-wrapper")) {
                closePopup();
            }
        };

        document.addEventListener("click", checkMenuClick);
        mounted = true;
        localHydrateCart(cart, $cart);
        return () => document.removeEventListener("click", checkMenuClick);
    });
</script>

<div class="ml-auto flex justify-center items-center">
    <!-- svelte-ignore a11y-no-static-element-interactions a11y-click-events-have-key-events -->
    <div class="cart cursor-pointer flex flex-row" on:click={cartPopupOpen.toggle}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="file: h-6 w-6"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
            />
        </svg>
        <div class="" class:hidden={!$cart.products.length}>
            <p class="flex h-2 w-2 items-center justify-center rounded-full bg-red-500 p-3 text-xs text-white">
                {$cart.products.length}
            </p>
        </div>
    </div>
</div>
{#if $cartPopupOpen}
    <div class="cart-wrapper relative m-0 p-0 mt-12" data-testid="cart-dialog">
        <div class="flex flex-wrap mx-0">
            <div class="cart-popup rounded-lg">
                <div class="w-full pr-0 pl-0 px-4">
                    <h2 class="mb-2">Din kundvagn</h2>
                    <div class="listing-wrapper">
                        <CartListingPopup {products} onNumChange={onNumChange(cart)} close={closePopup} />
                    </div>
                    <Spacer />
                    <div class="button-wrapper">
                        <Button primary={false} dark={true} on:click={closePopup} ariaLabel={"Fortsätt handla"}>
                            Fortsätt handla
                        </Button>
                        <AButton primary={true} href="/kassa" on:click={closePopup} ariaLabel="Till kassan">
                            Till kassan
                        </AButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .cart-popup {
        padding: 18px;
        text-align: initial;

        color: initial;
        position: absolute;
        max-height: 500px;
        width: 400px;
        background: rgba(255, 255, 255, 1);
        top: 30px;
        right: 0px;
        z-index: 12;
        box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.3);
        overflow: auto;
    }
    .listing-wrapper {
        height: auto;
        width: 100%;
        overflow-y: hidden;
        overflow-x: hidden;
    }
    .button-wrapper {
        display: flex;
        justify-content: space-between;
    }
</style>
